// 订单设置
<template>
  <div class="tape-detail" v-loading="loading">
    <el-card class="box-card">
      <span class="time"> {{ time }}</span>
      <div class="name">
        {{ order.xiaoqu }}_{{ order.name }} {{order.sex}} <br />
        <span>订单编号：{{ order.id }}</span>
      </div>
      <el-row class="nums">
        <el-col :span="8">
          <span>{{ call.call_num }}</span
          ><br />
          总呼叫次数
        </el-col>
        <el-col :span="8">
          <span>{{ call.call_on_num }}</span> <br />
          已接通
        </el-col>
        <el-col :span="8">
          <span>{{ call.call_un_num }}</span> <br />
          未接通
        </el-col>
      </el-row>
    </el-card>
    <el-row class="message">
      <div class="files">基础信息</div>
      <div class="item">
        <div class="left">手机号：</div>
        <div :class="['right', { set: !order.tel8 }]">{{ order.tel8 ? order.tel8 : '未设置' }}</div>
      </div>
      <div class="item">
        <div class="left">联系人：</div>
        <div :class="['right', { set: !order.name }]">{{ order.name ? order.name : '未设置' }}</div>
      </div>
      <div class="item">
        <div class="left">备用联系人：</div>
        <div :class="['right', { set: !order.standby_user }]">
          {{ order.standby_user ? order.standby_user : '未设置' }}
        </div>
      </div>
      <div class="item">
        <div class="left">备用联系：</div>
        <div :class="['right', { set: !order.other_contact }]">
          {{ order.other_contact ? order.other_contact : '未设置' }}
        </div>
      </div>
      <div class="item">
        <div class="left">备用联系人2：</div>
        <div :class="['right', { set: !order.standby_user_two }]">
          {{ order.standby_user_two ? order.standby_user_two : '未设置' }}
        </div>
      </div>
      <div class="item">
        <div class="left">备用联系2：</div>
        <div :class="['right', { set: !order.other_contact_two }]">
          {{ order.other_contact_two ? order.other_contact_two : '未设置' }}
        </div>
      </div>
      <div class="item">
        <div class="left">IP城市：</div>
        <div :class="['right', { set: !order.cname }]">{{ order.cname ? order.cname : '未设置' }}</div>
      </div>
      <div class="item">
        <div class="left">所属区域：</div>
        <div :class="['right', { set: !order.qz_area }]">{{ order.qz_area ? order.qz_area : '未设置' }}</div>
      </div>
      <div class="item">
        <div class="left">小区：</div>
        <div :class="['right', { set: !order.xiaoqu }]">{{ order.xiaoqu ? order.xiaoqu : '未设置' }}</div>
      </div>
      <div class="files">房屋信息</div>
      <div class="item">
        <div class="left">面积：</div>
        <div :class="['right', { set: !order.mianji }]">{{ order.mianji ? order.mianji + 'm²' : '未设置' }}</div>
      </div>
      <div class="item">
        <div class="left">钥匙：</div>
        <div class="right">{{ order.keys | filterKey }}</div>
      </div>
      <div class="item">
        <div class="left">房屋地址：</div>
        <div :class="['right w80', { set: !order.dz }]">{{ order.dz ? order.dz : '未设置' }}</div>
      </div>
      <!-- <div class="item">
        <div class="left">户型结构：</div>
        <div :class="['right', { set: !order.hxname }]">{{ order.hxname ? order.hxname : '未设置' }}</div>
      </div> -->
      <div class="item">
        <div class="left">预算：</div>
        <div :class="['right', { set: !order.yusuan }]">{{ order.yusuan ? order.yusuan : '未设置' }}</div>
      </div>
      <!-- <div class="item">
        <div class="left">风格：</div>
        <div :class="['right', { set: !order.fengge }]">{{ order.fengge ? order.fengge : '未设置' }}</div>
      </div> -->
      <!-- <div class="item">
        <div class="left">拿房时间：</div>
        <div :class="['right', { set: !order.nf_time || order.nf_time == '0000-00-00' }]">{{ order.nf_time && order.nf_time != "0000-00-00" ? order.nf_time : '未设置' }}</div>
      </div> -->
      <div class="item">
        <div class="left">开工时间：</div>
        <div :class="['right', { set: !order.start }]">{{ order.start ? order.start : '未设置' }}</div>
      </div>
      <div class="files">特殊需求</div>
      <el-card class="ts-card">
        <div v-html="text" v-if="text"></div>
        <div class='set' v-if="!text">未设置</div>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import apiTape from '@/api/tape';


export default {
  name: 'tapeDetail',
  filters: {
    filterKey(val) {
      const obj = ['无钥匙', '有钥匙', '-', '其他'];
      return obj[val];
    },
  },
  data() {
    return {
      orderId: '',
      loading: false,
      call: {},
      order: {},
      time: '',
      text: '',
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.getDetail(this.orderId);
    this.getList(this.orderId);
  },
  methods: {
    getList(e) {
      apiTape
        .orderLog({
          order_id: e,
        })
        .then((res) => {
          if (parseInt(res.data.error_code, 10) === 0) {
            this.call = res.data.data.stats;
          } else {
            this.loading = false;
            this.$message({
              type: 'error',
              message: res.data.error_msg,
              center: true,
              offset: 200,
            });
          }
        });
    },
    getDetail(e) {
      this.loading = true;
      apiTape
        .orderDetail({
          order_id: e,
        })
        .then((res) => {
          if (parseInt(res.data.error_code, 10) === 4000100) {
            const mode = localStorage.getItem('mode');
            console.log("mode",mode)
            if (mode === '2' || mode === '4') {
              this.$router.push({
                path: 'order-all',
                query: {
                  froms: 'tape',
                },
              });
            } else if (mode === '1' || mode === '3') {
              this.$router.push({
                path: 'order-listv1.0',
                query: {
                  froms: 'tape',
                },
              });
            }
            this.$message({
              type: 'error',
              message: res.data.error_msg,
              center: true,
              offset: 200,
            });
          } else if (parseInt(res.data.error_code, 10) === 0) {
            this.loading = false;
            const order = res.data.data;
            this.order = order;
            this.time = dayjs.unix(order.time).format('YYYY-MM-DD HH:mm:ss');
            this.text = order.text.replace(/\n/g, '<br/>');
          } else {
            this.loading = false;
            this.$message({
              type: 'error',
              message: res.data.error_msg,
              center: true,
              offset: 200,
            });
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.tape-detail {
  height: 88vh;
  overflow-y: auto;
  .box-card {
    color: #fff;
    line-height: 30px;
    background-color: #e84d56;
    .time {
      color: #f3a6aa;
      font-size: 8px;
    }
    .name {
      font-size: 18px;

      span {
        font-size: 14px;
      }
    }
    .nums {
      margin-top: 20px;
      font-size: 12px;
      text-align: center;
      span {
        font-size: 30px;
      }
    }
  }
  .message {
    padding: 20px;
    font-size: 14px;
    line-height: 40px;
    .files {
      color: #333;
      font-weight: bold;
      font-size: 16px;
    }
    .item {
      width: 100%;
      overflow: hidden;
      .left,
      .right {
        float: left;
      }
    }
    .ts-card {
      width: 100%;
      margin: 0 auto;
    }
    .set {
      color: #ccc;
    }
  }
  .w80{
    width: 72%;
  }
}
</style>
